// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-wrapper {
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
}
.error-wrapper .error-container {
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  width: 490px;
  height: 350px;
  align-items: center;
  justify-content: center;
  row-gap: 30px;
}
.error-wrapper .error-container .error-title {
  color: #142A31;
  font-size: 19px;
  font-weight: 700;
}
.error-wrapper .error-container .error-description {
  text-align: center;
  font-size: 14px;
  color: #365A64;
  width: 330px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ErrorPage/ErrorPage.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;AACE;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AACH;AAEE;EACC,kBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAAH","sourcesContent":[".error-wrapper {\n\tdisplay: flex;\n\twidth: 100vw;\n\theight: 100vh;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.error-container {\n\t\tbackground-color: #FFFFFF;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 490px;\n\t\theight: 350px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\trow-gap: 30px;\n\n\t\t.error-title {\n\t\t\tcolor: #142A31;\n\t\t\tfont-size: 19px;\n\t\t\tfont-weight: 700\n\t\t}\n\n\t\t.error-description {\n\t\t\ttext-align: center;\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #365A64;\n\t\t\twidth: 330px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
